import React from 'react';
import { useChanges } from "../../hooks/useChanges";
import {useAdvanceChanges} from '../../hooks/useAdvanceChanges'


const TogglerBody = ({ isOn, setIsOn, keyName, advance }) => {
    const { addChangeToStore } = useChanges();
    const { addAdvanceChangeToStore } = useAdvanceChanges();
    
    const handleChange = () => {
        if (keyName) {
            advance ? addAdvanceChangeToStore({ key: keyName, value: !isOn }) : addChangeToStore({ key: keyName, value: !isOn })
        }
        setIsOn(state => !state)
    }

    return (
            <div className={`toggler_wrap toggler_wrap_body ${isOn ? 'toggler_wrap_body_active' : ''}`}  onClick={handleChange}>
                <div className={`toggler_check toggler_check_body ${isOn ? 'toggler_on toggler_on_body' : 'toggler_off toggler_off_body'}`}></div>
            </div>
        );
};

export default TogglerBody;